<template>
  <AuthLayout title="Forgot Password">
    <ParagraphText class="mb-4"
      >Forgot your password? No problem. Just let us know your email address and
      we will email you a password reset link that will allow you to choose a
      new one.</ParagraphText
    >

    <ParagraphText
      font="font-medium"
      color="text-green-600"
      class="mb-4"
      v-if="props.status"
    >
      {{ props.status }}
    </ParagraphText>

    <form class="space-y-6" @submit.prevent="submit">
      <div>
        <InputGroup
          v-model="form.email"
          type="email"
          label="Email address"
          :error="form.errors.email"
          autocomplete="email"
          required
          autofocus
        />
      </div>
      <ButtonBase type="submit" :processing="form.processing"
        >Email Password Reset Link</ButtonBase
      >
    </form>
  </AuthLayout>
</template>

<script setup>
import { useForm } from '@inertiajs/inertia-vue3'

import AuthLayout from '@/Layouts/AuthLayout.vue'
import ButtonBase from '@/Common/Elements/Buttons/ButtonBase.vue'
import ParagraphText from '@/Common/Text/ParagraphText.vue'
import InputGroup from '@/Common/Forms/Inputs/InputGroup.vue'

const props = defineProps({
  status: String,
})

const form = useForm({
  email: null,
})

function submit() {
  form.post(route('password.email'), {
    onSuccess: () => form.reset(),
  })
}
</script>
